<section class="space-ptb">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10 col-md-12">
        <div class="login-register">
          <div class="section-title">
            <h4 class="text-center">Reset Password</h4>
          </div>

          <div class="tab-content">
            <div class="tab-pane active" id="candidate" role="tabpanel">
              <ng-container *ngIf="!isLoading && isPasswordReset && !codeExpired; else noPasswordSetTemplate ">
                <section>
                  <p class="text-success text-center font-weight-bold">Your password has been successfully changed.</p>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <a class="link" [routerLink]="['/signin']">Go back to Log In</a>
                  </div>
                </section>
              </ng-container>
              <ng-template #noPasswordSetTemplate>
                <form class="mt-4" [formGroup]="form">
                  <div class="form-row">
                    <div formGroupName="passwordGroup" class="form-group col-md-12">
                      <div class="col-md-12" style="float: left; padding-left: 0; padding-right: 5px;">
                        <label>Password *</label>
                        <input type="password" formControlName="password" placeholder="min 8 characters"
                          [class.is-valid]="!form?.get('passwordGroup.password')?.errors"
                          [class.is-invalid]="!form?.pristine && form?.get('passwordGroup.password')?.errors"
                          class="form-control">
                        <password-strength-meter [password]="form?.get('passwordGroup.password').value"
                          minPasswordLength="8"></password-strength-meter>
                      </div>
                      <div class="col-md-12" style="float: left; padding-left: 5px; padding-right: 0;">
                        <label for="password2">Confirm Password *</label>
                        <input type="password" formControlName="confirmPassword"
                          [class.is-valid]="!form?.get('passwordGroup.confirmPassword')?.pristine && !form?.hasError('notSame', 'passwordGroup')"
                          [class.is-invalid]="!form?.pristine && form?.get('passwordGroup.confirmPassword')?.errors"
                          class="form-control">
                        <span *ngIf="form?.hasError('notSame', 'passwordGroup')" style="color: red;">
                          Confirm password does not match to Password.
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="form-row">
                    <div class="col-md-6">
                      <button class="btn btn-primary d-block" [disabled]="form?.invalid || codeExpired" [routerLink]=""
                        (click)="confirmPasswordReset()">Reset Password</button>
                    </div>
                  </div>
                </form>
                <section *ngIf="codeExpired && !isLoading && !isPasswordReset">
                  <p class="text-danger font-weight-bold my-4">
                    Sorry, looks like the reset code has already been used or has expired.
                  </p>

                  <div fxLayout="row" fxLayoutAlign="start center my-2">
                    <a class="link" [routerLink]="'/forgot-password'">Go back to Forgot Password</a>
                  </div>
                </section>
              </ng-template>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
